import axios from 'axios'
// import localStoreService from '../util/localStoreService'
import { API_URL} from '../utils/config'

export default async function callApi (endpoint, method = 'get', body) {
    try {
        const response = await axios({
            method: method,
            url: `${API_URL}/${endpoint}`,
            data: body,
            headers: {
                'Content-Type': 'application/json',
            }
        })
        return response.data
    } catch (err) {
        console.log(err);
    }


}
